import { type Cluster } from '@/packages/query-state/shared/types/clusters/ClustersResponse';

interface ICheckIsHoverablePointProps {
  selectedPinId?: string;
  currentPin: Cluster;
}

/**
 * @description
 * Проверяет, можно ли обрабатывать hover на пине
 */
export const checkIsHoverablePoint = ({ selectedPinId, currentPin }: ICheckIsHoverablePointProps): boolean => {
  const isSelectedPin = selectedPinId === currentPin.id;
  const isExtendedPin = currentPin.properties?.outside;

  return !isSelectedPin && !isExtendedPin;
};
